export default __webpack_public_path__ + "77c47054354261e6064ef742fad8c888.png";